
  <ng-container *ngrxLet="selectActiveOrganization$;let activeOrganization">
    <ng-container *ngrxLet="selectUser$;let selectUser">

      <div class="sidebar-v2 flex-row h-100 w-100" [dir]="directionality.value">
        <div class="menu-level1 flex-col space-between-center" [class.rtl]="directionality.value === 'rtl'">
          <div class="flex-col">
            <img class="lumix-logo" src="assets/icons/logo.svg" alt="logo">
            <hr class="hr" style="margin: 16px 24px;">
            <!--    MENU ITEMS-->
            <div *ngFor="let item of mainMenuItems"
                 class="menu-item"
                 [matTooltip]="item.displayName|translate"
                 matTooltipPosition="right"
                 matTooltipClass="sidebar-tooltip"
            >
              <ng-container *ngrxLet="selectActiveOrganization$; let org">
                @if (!!item.href) {
                  <a
                    *rbacAllow="item.roles"
                    [href]="(item.disabled || item.path)?null:item.href"
                    routerLinkActive="active"
                    [target]="item.href?'_blanc':null"
                    class="flex-row"
                    [class.active]="activeState && item.path === routerSegments.locationV2" matRipple
                    matRippleColor="rgba(67, 103, 246, 0.1)"
                  >
                    <span *ngIf="!!item.class" [class]="item.class" class="icon"></span>
                    <mat-icon *ngIf="!!item?.svg" [svgIcon]="item.svg" class="icon"></mat-icon>
                    <mat-icon *ngIf="!!item?.icon" class="icon">{{ item.icon }}</mat-icon>
                  </a>
                } @else {
                  <a
                    *rbacAllow="item.roles"
                    [routerLink]="(item.disabled || item.href) ? null : '/' + item.path"
                    routerLinkActive="active"
                    [target]="item.href?'_blanc':null"
                    class="flex-row"
                    [class.active]="activeState && item.path === routerSegments.locationV2" matRipple
                    matRippleColor="rgba(67, 103, 246, 0.1)"
                  >
                    <span *ngIf="!!item.class" [class]="item.class" class="icon"></span>
                    <mat-icon *ngIf="!!item?.svg" [svgIcon]="item.svg" class="icon"></mat-icon>
                    <mat-icon *ngIf="!!item?.icon" class="icon">{{ item.icon }}</mat-icon>
                  </a>
                }

              </ng-container>
            </div>

            <div *ngIf="swUpdateAvailable" class="sw-update-window flex-col">
              <div class="flex-row start-center gap-12">
                <div class="icon-16 svg-fill-red flex-row center-center">
                  <mat-icon svgIcon="info"></mat-icon>
                </div>
                <div class="title">
                  {{ swUpdateTrial ? ('SIDEBAR.UPDATE_FAILED'|translate) : ('SIDEBAR.UPDATE_REQUIRED'|translate) }}
                </div>
              </div>
              <ng-container *ngIf="!swUpdateTrial; else failed">
                <div class="description">
                  {{ 'SIDEBAR.UPDATE_DESCRIPTION'|translate }}
                </div>
                <div class="flex-row start-center gap-8">
                  <ui-button type="primary"
                             [text]="'SIDEBAR.UPDATE_BUTTON_TEXT'|translate"
                             (clickAction)="reloadPage()"
                  ></ui-button>
                </div>
              </ng-container>
              <ng-template #failed>
                <div class="description">
                  {{ 'SIDEBAR.MANUAL_UPDATE_DESCRIPTION'|translate }}
                </div>
                <div class="flex-col start-start gap-8 w-100">
                  <div>Mac</div>
                  <input disabled class="ui-input ui-input-40 w-100" placeholder="Cmd + Shift + R">
                </div>
                <div class="flex-col start-start gap-8 w-100">
                  <div>Windows</div>
                  <input disabled class="ui-input ui-input-40 w-100" placeholder="Ctrl + F5">
                </div>
              </ng-template>

            </div>

          </div>
          <!--        BOTTOM MENU-->
          <div class="bottom-menu flex-col start-start"
               *ngrxLet="isDeveloper$; let isDeveloper"
          >
            <div class="help-icon-wrapper flex-row center-center">
              <mat-slide-toggle *ngIf="isDevTeam$|ngrxPush" [formControl]="darkThemeFormControl"
              ></mat-slide-toggle>
            </div>
            <div class="help-icon-wrapper flex-row center-center">
              <mat-slide-toggle *ifDeveloper
                                [formControl]="langControl"
                                [matTooltip]="langControl.value?'Switch lang to hebrew':'Switch lang to english'"
              ></mat-slide-toggle>
            </div>
            <div *ifMagentrix class="help-icon-wrapper flex-row center-center" [class.active]="isHelpSection"
                 [matTooltip]="'MAIN_MENU.PARTNERS'|translate"
                 matTooltipClass="sidebar-tooltip"
                 matTooltipPosition="right"
            >
               <span class="help-icon ui-icon-cat-safety icon" (click)="magentrixLogin()"
               ></span>
            </div>
            <div class="help-icon-wrapper flex-row center-center" [class.active]="isHelpSection"
                 [matTooltip]="'SIDEBAR.HELP_TOOLTIP'|translate"
                 matTooltipClass="sidebar-tooltip"
                 matTooltipPosition="right"
            >
               <span class="help-icon ui-icon-help icon" (click)="about(isDeveloper)"
               ></span>
            </div>
            <div class="user-icon-wrapper flex-row center-center"
                 [matTooltip]="'SIDEBAR.USER_TOOLTIP'|translate"
                 matTooltipClass="sidebar-tooltip"
                 matTooltipPosition="right"
            >
              <!--            USER SUB MENU-->
              <app-ui-dropdown [height]="userMenuHeight" #userMenuDropdown>
                <div input class="flex-row center-center w-100">
                  <span class="user-icon icon ui-icon-user"></span>
                </div>

                <ng-template #contentTemplate>
                  <div class="user-menu" #userMenu>
                    <div class="user-menu-inner flex-col">
                      <ng-container *ngIf="selectUser">
                        <div class="menu-title">
                          {{ selectUser.firstname }} {{ selectUser.lastname }}
                        </div>
                        <div class="menu-title">
                          {{ selectUser.email }}
                        </div>
                      </ng-container>
                      <hr class="hr"/>
                      <div
                        class="flex-row start-center menu-item"
                        [routerLink]="routerSegments.account"
                        (click)="userMenuDropdown.toggleDropdown()"
                      >
                        <div class="flex-row start-center gap-8">
                          <span class="icon ui-icon-settings"></span>
                          <span>{{ 'SIDEBAR.USER_MENU.SETTINGS' | translate }}</span>
                        </div>
                      </div>
                      <div
                        class="menu-item logout-button flex-row space-between-center"
                        (click)="logout();userMenuDropdown.toggleDropdown()"
                      >
                        <div class="flex-row start-center gap-8">
                          <span class="icon ui-icon-logout"></span>
                          <span>{{ 'SIDEBAR.USER_MENU.LOGOUT' | translate }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </app-ui-dropdown>


            </div>

            <hr class="hr" style="margin: 8px 24px; width: 20px;">

            <!--      ORG SUB MENU-->

            <div class="active-organization w-100"
                 [matTooltip]="'SIDEBAR.ORG_TOOLTIP'|translate"
                 matTooltipClass="sidebar-tooltip"
                 matTooltipPosition="right"
            >
              <div class="w-100" style="padding: 8px 0">

                <app-ui-dropdown [height]="userMenuHeight" #orgMenuDropdown>
                  <div input class="flex-row center-center w-100">
                    <ui-avatar class="org-avatar"
                               [name]="activeOrganization?.orgName"
                               [color]="activeOrganization?.orgColor"
                    ></ui-avatar>
                  </div>

                  <ng-template #contentTemplate>
                    <div class="user-menu" #orgMenu>
                      <div class="user-menu-inner flex-col">
                        <div class="menu-title">
                          <ui-truncated-html class="truncated-name">
                            {{ activeOrganization?.orgName }}
                          </ui-truncated-html>
                        </div>
                        <hr class="hr">
                        <div class="menu-item">
                          <div class="flex-row start-center gap-8"
                               (click)="toggleSwitchOrgMenu();orgMenuDropdown.toggleDropdown()"
                          >
                            <span class="icon ui-icon-company"></span>
                            <span>{{ 'SIDEBAR.ORG_MENU.SWITCH_ORG'|translate }}</span>
                          </div>
                        </div>
                        <div *rbacOrgAllow="[permissions.OrganizationDatabase]"
                             class="menu-item"
                             [routerLink]="routerSegments.database"
                             (click)="orgMenuDropdown.toggleDropdown()"

                        >
                          <div class="flex-row start-center gap-8 ">
                            <span class="icon ui-icon-dashboard"></span>
                            <span>{{ 'SIDEBAR.ORG_MENU.DATABASE'|translate }}</span>
                          </div>
                        </div>
                        <div class="menu-item"
                             [routerLink]="routerSegments.settings"
                             (click)="orgMenuDropdown.toggleDropdown()"
                        >
                          <div class="flex-row start-center gap-8 ">
                            <span class="icon ui-icon-settings"></span>
                            <span>{{ 'SIDEBAR.ORG_MENU.SETTINGS'|translate }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </ng-template>
                </app-ui-dropdown>

              </div>


            </div>

          </div>

        </div>
        <!--      SELECT ORGANIZATION -->
        <ng-container>
          <app-switch-organization *ngIf="isOrgSelectorOpen"
                                   [position]="directionality.value==='ltr'?'left':'right'"
                                   [activeOrganization]="activeOrganization"
                                   [userOrganizations]="selectUserOrganizationsDropdown$|async"
                                   (onMenuClosed)="closeSwitchOrgMenu()"
          ></app-switch-organization>
        </ng-container>

        <!--    CONTENT OF ROUTES-->
        <div class="root-content-wrapper">
          <router-outlet></router-outlet>
        </div>

      </div>
    </ng-container>
  </ng-container>
